// ============ WARNA TEMA DINAMIK ============
// Superadmin boleh pilih warna utama aplikasi dari panel Tetapan.
// Modul ini menjana CSS override yang memetakan semula kelas 'purple'
// Tailwind kepada palet warna pilihan, disuntik pada <head>.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = "app_theme_color";
const STYLE_ID = "custom-theme-style";

// Palet penuh (shade 50-700) untuk setiap tema
export const THEME_PALETTES = {
  pink:   { 50:"#fdf2f8",100:"#fce7f3",200:"#fbcfe8",300:"#f9a8d4",400:"#f472b6",500:"#ec4899",600:"#db2777",700:"#be185d" },
  blue:   { 50:"#eff6ff",100:"#dbeafe",200:"#bfdbfe",300:"#93c5fd",400:"#60a5fa",500:"#3b82f6",600:"#2563eb",700:"#1d4ed8" },
  green:  { 50:"#f0fdf4",100:"#dcfce7",200:"#bbf7d0",300:"#86efac",400:"#4ade80",500:"#22c55e",600:"#16a34a",700:"#15803d" },
  teal:   { 50:"#f0fdfa",100:"#ccfbf1",200:"#99f6e4",300:"#5eead4",400:"#2dd4bf",500:"#14b8a6",600:"#0d9488",700:"#0f766e" },
  amber:  { 50:"#fffbeb",100:"#fef3c7",200:"#fde68a",300:"#fcd34d",400:"#fbbf24",500:"#f59e0b",600:"#d97706",700:"#b45309" },
  rose:   { 50:"#fff1f2",100:"#ffe4e6",200:"#fecdd3",300:"#fda4af",400:"#fb7185",500:"#f43f5e",600:"#e11d48",700:"#be123c" },
  indigo: { 50:"#eef2ff",100:"#e0e7ff",200:"#c7d2fe",300:"#a5b4fc",400:"#818cf8",500:"#6366f1",600:"#4f46e5",700:"#4338ca" },
  cyan:   { 50:"#ecfeff",100:"#cffafe",200:"#a5f3fc",300:"#67e8f9",400:"#22d3ee",500:"#06b6d4",600:"#0891b2",700:"#0e7490" },
  orange: { 50:"#fff7ed",100:"#ffedd5",200:"#fed7aa",300:"#fdba74",400:"#fb923c",500:"#f97316",600:"#ea580c",700:"#c2410c" },
};

// Label & swatch untuk UI pemilih warna
export const THEME_OPTIONS = [
  { key: "", label: "Ungu (Asal)", swatch: "#a855f7" },
  { key: "pink", label: "Merah Jambu", swatch: "#ec4899" },
  { key: "rose", label: "Rose", swatch: "#f43f5e" },
  { key: "orange", label: "Oren", swatch: "#f97316" },
  { key: "amber", label: "Kuning Emas", swatch: "#f59e0b" },
  { key: "green", label: "Hijau", swatch: "#22c55e" },
  { key: "teal", label: "Teal", swatch: "#14b8a6" },
  { key: "cyan", label: "Cyan", swatch: "#06b6d4" },
  { key: "blue", label: "Biru", swatch: "#3b82f6" },
  { key: "indigo", label: "Indigo", swatch: "#6366f1" },
];

const hexToRgb = (hex) => {
  const h = hex.replace("#", "");
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
};

// Jana CSS yang memetakan kelas purple-* kepada palet baharu
const buildThemeCss = (palette) => {
  const rules = [];
  const opacities = [10, 20, 30, 40, 50, 60, 70, 80, 90];
  const transparent = "rgb(255 255 255 / 0)";

  Object.entries(palette).forEach(([shade, hex]) => {
    const [r, g, b] = hexToRgb(hex);
    // Latar & teks & border padat
    rules.push(`.bg-purple-${shade}{background-color:${hex} !important}`);
    rules.push(`.hover\\:bg-purple-${shade}:hover{background-color:${hex} !important}`);
    rules.push(`.text-purple-${shade}{color:${hex} !important}`);
    rules.push(`.hover\\:text-purple-${shade}:hover{color:${hex} !important}`);
    rules.push(`.border-purple-${shade}{border-color:${hex} !important}`);
    rules.push(`.ring-purple-${shade}{--tw-ring-color:${hex} !important}`);
    // Gradient
    rules.push(`.from-purple-${shade}{--tw-gradient-from:${hex} var(--tw-gradient-from-position) !important;--tw-gradient-to:${transparent} var(--tw-gradient-to-position) !important;--tw-gradient-stops:var(--tw-gradient-from), var(--tw-gradient-to) !important}`);
    rules.push(`.hover\\:from-purple-${shade}:hover{--tw-gradient-from:${hex} var(--tw-gradient-from-position) !important;--tw-gradient-to:${transparent} var(--tw-gradient-to-position) !important;--tw-gradient-stops:var(--tw-gradient-from), var(--tw-gradient-to) !important}`);
    rules.push(`.via-purple-${shade}{--tw-gradient-to:${transparent} var(--tw-gradient-to-position) !important;--tw-gradient-stops:var(--tw-gradient-from), ${hex} var(--tw-gradient-via-position), var(--tw-gradient-to) !important}`);
    rules.push(`.to-purple-${shade}{--tw-gradient-to:${hex} var(--tw-gradient-to-position) !important}`);
    rules.push(`.hover\\:to-purple-${shade}:hover{--tw-gradient-to:${hex} var(--tw-gradient-to-position) !important}`);
    // Varian keterlihatan (cth: bg-purple-500/20)
    opacities.forEach((o) => {
      rules.push(`.bg-purple-${shade}\\/${o}{background-color:rgba(${r},${g},${b},0.${o < 10 ? "0" + o : o}) !important}`);
      rules.push(`.border-purple-${shade}\\/${o}{border-color:rgba(${r},${g},${b},0.${o < 10 ? "0" + o : o}) !important}`);
      rules.push(`.from-purple-${shade}\\/${o}{--tw-gradient-from:rgba(${r},${g},${b},0.${o}) var(--tw-gradient-from-position) !important;--tw-gradient-to:${transparent} var(--tw-gradient-to-position) !important;--tw-gradient-stops:var(--tw-gradient-from), var(--tw-gradient-to) !important}`);
      rules.push(`.to-purple-${shade}\\/${o}{--tw-gradient-to:rgba(${r},${g},${b},0.${o}) var(--tw-gradient-to-position) !important}`);
    });
  });
  return rules.join("\n");
};

// Suntik / buang <style> tema
export const applyTheme = (themeKey) => {
  const existing = document.getElementById(STYLE_ID);
  if (!themeKey || themeKey === "purple" || !THEME_PALETTES[themeKey]) {
    if (existing) existing.remove();
    return;
  }
  const css = buildThemeCss(THEME_PALETTES[themeKey]);
  if (existing) {
    existing.textContent = css;
  } else {
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }
};

// Simpan pilihan & terus pakai (dipanggil dari panel superadmin)
export const setThemeLocal = (themeKey) => {
  try {
    if (themeKey) localStorage.setItem(STORAGE_KEY, themeKey);
    else localStorage.removeItem(STORAGE_KEY);
  } catch (e) { /* ignore */ }
  applyTheme(themeKey);
};

export const getStoredTheme = () => {
  try { return localStorage.getItem(STORAGE_KEY) || ""; } catch (e) { return ""; }
};

// ============ TEMA PENUH APLIKASI (5 GAYA) ============
// Berbeza font, animasi, ikon, efek & latar - dipasang sebagai kelas pada <body>
const STYLE_STORAGE_KEY = "app_style_theme";
export const STYLE_THEME_KEYS = ["candy", "space", "minimal", "glass", "nature"];

export const STYLE_THEME_OPTIONS = [
  {
    key: "",
    label: "Asal (Default)",
    font: "Sistem",
    desc: "Rupa asal aplikasi tanpa perubahan",
    swatches: ["#a855f7", "#ec4899", "#f4f2fb"],
    fontFamily: "inherit",
  },
  {
    key: "candy",
    label: "Candy Pop",
    font: "Fredoka",
    desc: "Ceria & bulat - animasi melantun, ikon tebal, latar gula-gula pastel",
    swatches: ["#f472b6", "#fde68a", "#a5f3fc"],
    fontFamily: "'Fredoka', sans-serif",
  },
  {
    key: "space",
    label: "Angkasa Neon",
    font: "Space Grotesk",
    desc: "Kosmik & bercahaya - ikon glow neon, bintang, kad terapung",
    swatches: ["#6366f1", "#38bdf8", "#e879f9"],
    fontFamily: "'Space Grotesk', sans-serif",
  },
  {
    key: "minimal",
    label: "Minimal Pro",
    font: "Inter",
    desc: "Bersih & profesional - sudut kemas, ikon nipis, animasi pantas halus",
    swatches: ["#101828", "#667085", "#f6f7f9"],
    fontFamily: "'Inter', sans-serif",
  },
  {
    key: "glass",
    label: "Kaca Aura",
    font: "Poppins",
    desc: "Glassmorphism - kad kaca kabur, latar gradient bergerak perlahan",
    swatches: ["#ffd9e8", "#d9e8ff", "#d9fff2"],
    fontFamily: "'Poppins', sans-serif",
  },
  {
    key: "nature",
    label: "Taman Hijau",
    font: "Quicksand",
    desc: "Alam semula jadi - hijau tenang, ikon bergoyang, kad tumbuh lembut",
    swatches: ["#4ade80", "#bef264", "#f2fbf3"],
    fontFamily: "'Quicksand', sans-serif",
  },
];

// Pasang kelas tema pada <body> (buang kelas tema lain dahulu)
export const applyStyleTheme = (styleKey) => {
  const body = document.body;
  STYLE_THEME_KEYS.forEach((k) => body.classList.remove(`style-${k}`));
  if (styleKey && STYLE_THEME_KEYS.includes(styleKey)) {
    body.classList.add(`style-${styleKey}`);
  }
};

export const setStyleThemeLocal = (styleKey) => {
  try {
    if (styleKey) localStorage.setItem(STYLE_STORAGE_KEY, styleKey);
    else localStorage.removeItem(STYLE_STORAGE_KEY);
  } catch (e) { /* ignore */ }
  applyStyleTheme(styleKey);
};

export const getStoredStyleTheme = () => {
  try { return localStorage.getItem(STYLE_STORAGE_KEY) || ""; } catch (e) { return ""; }
};

// ============ MOD PERAYAAN (HIASAN BERMUSIM) ============
// Hiasan automatik ikut tarikh atau pilihan manual superadmin
const FESTIVE_STORAGE_KEY = "app_festive_mode";
export const FESTIVE_KEYS = ["raya", "merdeka", "cny", "deepavali", "krismas"];

export const FESTIVE_OPTIONS = [
  { key: "raya", label: "Raya Aidilfitri", desc: "Bunting hijau-emas, anak bulan & cahaya pelita", swatches: ["#15803d", "#d4a017"] },
  { key: "merdeka", label: "Merdeka & Hari Malaysia", desc: "Jalur Gemilang, bintang kuning & pancaran biru-merah", swatches: ["#cc0001", "#010066", "#ffcc00"] },
  { key: "cny", label: "Tahun Baru Cina", desc: "Bunting merah-emas & cahaya tanglung", swatches: ["#dc2626", "#f59e0b"] },
  { key: "deepavali", label: "Deepavali", desc: "Bunting ungu-jingga & corak kolam berwarna", swatches: ["#7c3aed", "#f97316"] },
  { key: "krismas", label: "Krismas", desc: "Bunting merah-hijau & salji turun perlahan", swatches: ["#dc2626", "#16a34a"] },
];

// Julat tarikh automatik (bulan 1-12): [bulanMula, hariMula, bulanTamat, hariTamat]
// Tarikh perayaan Islam/Cina/Hindu berubah setiap tahun - julat anggaran 2026-2028
const FESTIVE_RANGES = {
  2026: {
    cny: [2, 10, 2, 24],
    raya: [3, 13, 3, 27],
    deepavali: [10, 30, 11, 10],
  },
  2027: {
    cny: [1, 30, 2, 13],
    raya: [3, 2, 3, 16],
    deepavali: [10, 20, 11, 1],
  },
  2028: {
    cny: [1, 19, 2, 2],
    raya: [2, 19, 3, 4],
    deepavali: [10, 7, 10, 19],
  },
};

const inRange = (m, d, [sm, sd, em, ed]) => {
  const v = m * 100 + d;
  return v >= sm * 100 + sd && v <= em * 100 + ed;
};

// Kesan perayaan semasa berdasarkan tarikh hari ini
export const getAutoFestival = (date = new Date()) => {
  const m = date.getMonth() + 1;
  const d = date.getDate();
  // Merdeka (31 Ogos) hingga Hari Malaysia (16 Sep) - setiap tahun: 15 Ogos - 17 Sep
  if (inRange(m, d, [8, 15, 9, 17])) return "merdeka";
  // Krismas - setiap tahun: 15 - 26 Dis
  if (inRange(m, d, [12, 15, 12, 26])) return "krismas";
  const yearly = FESTIVE_RANGES[date.getFullYear()];
  if (yearly) {
    for (const key of Object.keys(yearly)) {
      if (inRange(m, d, yearly[key])) return key;
    }
  }
  return "";
};

// Tukar mod ("", "auto", atau kunci perayaan) kepada perayaan sebenar untuk dipaparkan
export const resolveFestive = (mode) => {
  if (!mode) return "";
  if (mode === "auto") return getAutoFestival();
  return FESTIVE_KEYS.includes(mode) ? mode : "";
};

// Pasang kelas hiasan perayaan pada <body>
export const applyFestive = (festKey) => {
  const body = document.body;
  FESTIVE_KEYS.forEach((k) => body.classList.remove(`festive-${k}`));
  if (festKey && FESTIVE_KEYS.includes(festKey)) {
    body.classList.add(`festive-${festKey}`);
  }
};

export const setFestiveLocal = (mode) => {
  try {
    if (mode) localStorage.setItem(FESTIVE_STORAGE_KEY, mode);
    else localStorage.removeItem(FESTIVE_STORAGE_KEY);
  } catch (e) { /* ignore */ }
  applyFestive(resolveFestive(mode));
};

export const getStoredFestive = () => {
  try { return localStorage.getItem(FESTIVE_STORAGE_KEY) || ""; } catch (e) { return ""; }
};

// Init pada muatan aplikasi: guna cache localStorage dahulu, kemudian sahkan dari server
export const initTheme = () => {
  applyTheme(getStoredTheme());
  applyStyleTheme(getStoredStyleTheme());
  applyFestive(resolveFestive(getStoredFestive()));
  fetch(`${BACKEND_URL}/api/settings/app-name`)
    .then((r) => r.json())
    .then((data) => {
      const serverTheme = data?.theme_color || "";
      if (serverTheme !== getStoredTheme()) {
        setThemeLocal(serverTheme);
      }
      const serverStyle = data?.style_theme || "";
      if (serverStyle !== getStoredStyleTheme()) {
        setStyleThemeLocal(serverStyle);
      }
      const serverFestive = data?.festive_mode || "";
      // Sentiasa selaraskan mod perayaan (auto perlu dinilai semula setiap muatan)
      setFestiveLocal(serverFestive);
    })
    .catch(() => { /* offline - kekal cache */ });
};
